import React from 'react';
import {Navigate} from 'react-router-dom';
import {ProtectedRoute} from '../components';
import {ROUTES} from '../constants/routes';
import {GiveRecco} from '../pages';
import Aura from '../pages/aura';
import CreateOpportunity from '../pages/create-opportunity';
import Dashboard from '../pages/dashboard';
import EditOpportunity from '../pages/edit-opportunity';
import JobApplicantScreen from '../pages/job-applicant';
import {LoginPage} from '../pages/login';
import {OnboardingPage} from '../pages/onboarding';
import Opportunities from '../pages/opportunities';
import OpportunityDetail from '../pages/opportunity-detail';
import PublicProfilePage from '../pages/public-profile';
import SavedCandidatesPage from '../pages/saved-candidates';
import SearchCandidatesPage from '../pages/search-candidates';
import Settings from '../pages/settings';
import {SignupPage} from '../pages/signup';
import {VerifyEmailPage} from '../pages/verify-email';

export const routes = [
  {
    path: '/',
    element: <Navigate to="/opportunities" replace />,
  },
  {
    path: '/give-recco',
    element: (
      <ProtectedRoute requireAuth={true}>
        <GiveRecco />
      </ProtectedRoute>
    ),
  },
  {
    path: '/aura',
    element: (
      <ProtectedRoute requireAuth={true}>
        <Aura />
      </ProtectedRoute>
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute requireAuth={true}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/opportunities',
    element: (
      <ProtectedRoute requireAuth={true}>
        <Opportunities />
      </ProtectedRoute>
    ),
  },
  {
    path: '/opportunities/create',
    element: (
      <ProtectedRoute requireAuth={true}>
        <CreateOpportunity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/opportunities/:id/edit',
    element: (
      <ProtectedRoute requireAuth={true}>
        <EditOpportunity />
      </ProtectedRoute>
    ),
  },
  {
    path: '/opportunities/:id',
    element: (
      <ProtectedRoute requireAuth={true}>
        <OpportunityDetail />
      </ProtectedRoute>
    ),
  },
  {
    path: '/opportunities/:id/applicants',
    element: (
      <ProtectedRoute requireAuth={true}>
        <JobApplicantScreen />
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTES.PUBLIC_PROFILE,
    element: <PublicProfilePage />,
  },
  {
    path: '/search-candidates',
    element: (
      <ProtectedRoute requireAuth={true}>
        <SearchCandidatesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/search-candidates/saved',
    element: (
      <ProtectedRoute requireAuth={true}>
        <SavedCandidatesPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute requireAuth={true}>
        <Settings />
      </ProtectedRoute>
    ),
  },
  {
    path: '/signup',
    element: (
      <ProtectedRoute requireAuth={false}>
        <SignupPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/login',
    element: (
      <ProtectedRoute requireAuth={false}>
        <LoginPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/verify-email',
    element: (
      <ProtectedRoute requireAuth={false}>
        <VerifyEmailPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/onboarding',
    element: (
      <ProtectedRoute requireAuth={false}>
        <OnboardingPage />
      </ProtectedRoute>
    ),
  },
];
